import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import betaIcon from "../../assets/card-icons/beta-notext.svg";
import deleteIcon from "../../assets/card-icons/delete.svg";
import stableIcon from "../../assets/card-icons/stable-notext.svg";
import closeIcon from "../../assets/close.svg";
import cartIcon from "../../assets/nav-icons/cart-black.svg";
import prodIcon from "../../assets/nav-icons/production-black.svg";
import { getDetails, postDetails } from "../../services/http/http.service";
import { setUserCartItems, setUserProdCartItems } from "../../store/authentication/authentication.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { setCart, setShowSideModal } from "../../store/selectedAPIs/selectedAPIs.slice";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import CustomButton from "../CustomButton/CustomButton";
import "./modals.css";
import SideModalWrapper from "./SideModalWrapper";
import { NavList } from "../../utils/constants/navigation";
import { message } from "../../utils/constants/Messages";

const RightModal: React.FunctionComponent = () => {
  const isMounted = useRef(false);
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { sideModalOption, cart } = useAppSelector(StoreSelectors.SELECTED_STATE);
  const { prodCartItems, cartItems, access } = useAppSelector(StoreSelectors.USER_STATE);

  const [cartAPIs, setCartAPIs] = useState([] as any);

  const getCart = async () => {
    try {
      dispatch(showLoader(message.LOADING));

      if (access.hasUATAccess && sideModalOption === "cart") {
        const response = await getDetails(APIList.GET_CART_ITEMS, () => getCart());
        if (response?.statusCode === APIResponseCodes.SUCCESS) {
          dispatch(setCart(response.data));
        }
      }

      if (access.hasProdAccess && sideModalOption === "prod") {
        const response = await getDetails(APIList.GET_ALL_PROD_CART_ITEMS, () => getCart());
        if (response?.statusCode === APIResponseCodes.SUCCESS) {
          dispatch(setCart(response.data.api_list));
        }
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
    }
  };

  useEffect(() => {
    if (isMounted.current === false) {
      getCart()
    }

    isMounted.current = true;
  }, [sideModalOption]);

  useEffect(() => {
    if (cart.length !== 0) {
      setCartAPIs(cart);
    }
  }, [cart]);

  /** Close sidemodal */
  const closeModal = () => dispatch(setShowSideModal(false));

  /** Delete an item from cart */
  const handleCartItemDelete = async (api: any) => {
    dispatch(showLoader(message.REMOVING_FROM_CART));
    let url =
      sideModalOption === "prod"
        ? APIList.REMOVE_FROM_PROD_CART
        : APIList.REMOVE_CART_ITEM;

    const response = await postDetails(url, {
      groupId: api.group_id,
      groupVersionId: api.group_version_id
    }, () => handleCartItemDelete(api));

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      const result = cart.filter((item: any) => item.group_version_id !== api.group_version_id);
      if (sideModalOption === "prod") {
        const ids = prodCartItems.filter((currentid: any) => currentid !== api.group_version_id);
        dispatch(setCart(result));
        setCartAPIs(result);
        dispatch(setUserProdCartItems(ids));
      } else {
        const ids = cartItems.filter((currentid: number) => currentid !== api.group_version_id);
        dispatch(setCart(result));
        setCartAPIs(result);
        dispatch(setUserCartItems(ids));
      }
    }

    dispatch(hideLoader());
  };

  const
    handleCheckoutClick = () => {
      dispatch(setShowSideModal(false));
      if (sideModalOption === "cart") {
        navigate(NavList.CART);
      }

      if (sideModalOption === "prod") {
        // navigate(NavList.PRODUCTION_LEGAL);
        //direct route to checkout page skip legal and agreement page
        navigate(NavList.PRODUCTION_CHECKOUT);
      }
    };


  return (
    <SideModalWrapper>
      <div className="right-modal-header d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          {sideModalOption === "cart" && (
            <img width={15} height={15} src={cartIcon} alt="cart" />
          )}
          {sideModalOption === "prod" && (
            <img
              className="me-2"
              width={24}
              height={24}
              src={prodIcon}
              alt="production"
            />
          )}
          {sideModalOption === "access" ? (
            <p className="mb-0 text-capitalize weight-600 font-14 ms-1">
              Manage Access
            </p>
          ) : (
            <p className="mb-0 text-capitalize weight-600 font-14 ms-1">
              {sideModalOption === "cart" ? "cart" : "production"}
            </p>
          )}
        </div>
        <div onClick={closeModal} className="cursor-pointer right-modal-close">
          <img width="21" height="21" src={closeIcon} alt="close" />
        </div>
      </div>

      <div className="right-modal-body custom-scrollbar mb-2">
        {sideModalOption !== "access" &&
          <div className="right-modal-body-count weight-400 text-primary-color">
            {cartAPIs.length + " items"}
          </div>
        }
        {sideModalOption !== "access" && (
          <div className="right-modal-body-contents">
            <div className="">
              {cartAPIs.length !== 0 &&
                cartAPIs.map((api: any, index: number) => (
                  <div className="right-modal-body-content" key={index}>
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex">
                        {api.enviroment === "beta" && (
                          <img
                            width={48}
                            height={48}
                            src={betaIcon}
                            alt="beta"
                          />
                        )}
                        {api.enviroment === "prod" && (
                          <img
                            width={48}
                            height={48}
                            src={stableIcon}
                            alt="stable"
                          />
                        )}
                        <div className="ms-2 right-modal-content-text">
                          <p className="mb-0 weight-500">{api.group_name}</p>
                          <span className="mb-0 text-capitalize d-block mt-1 weight-400">
                            v
                            {`${api.group_version}`.length === 1
                              ? ` ${api.group_version}.0`
                              : " " + api.group_version}
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={() => handleCartItemDelete(api)}
                        type="button"
                        className="right-modal-delete-btn border-0"
                      >
                        <img
                          width={14}
                          height={14}
                          src={deleteIcon}
                          alt="delete"
                        />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
      <div className="right-modal-body-action primary-bg-color py-1 w-100">
        {
          sideModalOption !== "access" &&
          <CustomButton
            disabled={cart.length === 0}
            onClick={handleCheckoutClick}
            size="md"
          >
            Checkout
          </CustomButton>
        }
      </div>
    </SideModalWrapper>
  );
};

export default RightModal;
